// extracted by mini-css-extract-plugin
module.exports = {"mobileContainer":"style_mobileContainer__T0R2h","mobileContent":"style_mobileContent__WvY_6","backgroundOverlayColor":"style_backgroundOverlayColor__YMnKZ"};